module.exports = __webpack_public_path__ + "img/TW.3e52922a.png";